import React from "react";

import { Form } from "@flowable/forms";
import PropTypes from "prop-types";

import { additionalData } from "containers/Form/additionalData";
import { onOutcomePressed } from "utils";
import { executeRequest } from "utils/proxy";

import Components from "../Components";

import "./styles.css";
import "@flowable/forms/flwforms.min.css";

const FLOWABLE_SHOW_FORMS_DEBUG = false;

// TODO replace other @flowable/forms/Form components with this to avoid unnecessary code

const FlowableForm = (
	{
		children,
		enabled,
		formConfig,
		formVariables,
		onChange,
		onValidChange,
		formRef,
		debug,
		...otherProps
	}
) => {
	const fetchData = (url, options) =>
		executeRequest(url.replaceAll("&", encodeURIComponent("&")), options)
			.then(data => {
				// executeRequest resolves the parsed body only when the request succeeded
				// (checkResponseStatus throws on non-2xx), so a resolved value is always a 2xx.
				// @flowable/forms 3.17's Fetch contract expects headers + status in addition to
				// json/text (Pick<Response, "json"|"text"|"headers"|"status">); omitting them
				// breaks engine paths that read response.status / response.headers.get(...).
				const isJson = data !== null && typeof data === "object";

				return {
					json: () => Promise.resolve(data),
					text: () => Promise.resolve(JSON.stringify(data)),
					headers: new Headers({"Content-Type": isJson ? "application/json" : "text/plain"}),
					status: 200,
				};
			}
		);

	return (
		<Form
			{...otherProps}
			Components={Components}
			additionalData={additionalData}
			config={formConfig}
			debug={(debug !== null && debug) || FLOWABLE_SHOW_FORMS_DEBUG}
			enabled={enabled}
			fetch={fetchData}
			payload={formVariables}
			ref={formRef}
			onChange={onChange}
			onOutcomePressed={onOutcomePressed}
			onValidChange={onValidChange}
		>
			{children}
		</Form>
	);
};

FlowableForm.defaultProps = {
	children: null,
	debug: false,
	enabled: false,
	formRef: null,
	onChange: null,
	onValidChange: null,
};

FlowableForm.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.arrayOf(PropTypes.node), PropTypes.node ]),
	debug: PropTypes.bool,
	enabled: PropTypes.bool,
	formConfig: PropTypes.any.isRequired,
	formRef: PropTypes.oneOfType([ PropTypes.func, PropTypes.shape({ current: PropTypes.any }) ]),
	formVariables: PropTypes.any.isRequired,
	onChange: PropTypes.func,
	onValidChange: PropTypes.func,
};

export default FlowableForm;
